import React from 'react';

const ShVideo3dTour = ({ title, id, customclass, iframesrc }) => {
  return (
    <sh-video-3d-tour
      title={title}
      id={id}
      customclass={customclass}
      iframesrc={iframesrc}>
    </sh-video-3d-tour>
  )
};

export default class ShVideo3dTours extends React.Component {
  render() {
    const { hasSothebysVirtualUrl, virtualTour, virtual3d, interactiveFloorPlan } = this.props.listing;

    const virtualTourEl = virtual3d && (
      <div id="virtual" tabIndex="-1">
        <ShVideo3dTour
          title="Virtual Tour"
          iframesrc={virtual3d}
          id="virtual-tour"
        ></ShVideo3dTour>
        <div className="spacer-small"></div>
      </div>
    );

    const virtualSh3dTourEl = virtualTour && hasSothebysVirtualUrl && (
      <div>
        <ShVideo3dTour
          title="Virtual Tour 3D"
          iframesrc={virtualTour}
          id="irtual-tour-3d"
          customclass="sirTour"
        ></ShVideo3dTour>
        <div className="spacer-small"></div>
      </div>
    );

    const virtual3dTourEl = virtualTour && !hasSothebysVirtualUrl && (
      <div>
        <h3>
          <span className="title">
            <a
              style={{ color: '#0275d8', textDecoration: 'underline' }}
              href={virtualTour}
              title="Virtual Tour 3D"
              target="_blank"
            >Virtual Tour 3D</a>
          </span>
        </h3>
        <div className="spacer-small"></div>
      </div>
    );

    const interactiveFloorPlanEl = interactiveFloorPlan && (
      <div tabIndex="-1">
        <ShVideo3dTour
          title="Interactive floor plan"
          iframesrc={interactiveFloorPlan}
          id="interactive-floorplan"
        ></ShVideo3dTour>
        <div className="spacer-small"></div>
      </div>
    );

    return (
      <div id="virtualtour" className="col-xs-12">
        {virtualTourEl}
        {virtualSh3dTourEl}
        {virtual3dTourEl}
        {interactiveFloorPlanEl}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-video-3d-tours.js